// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__AfDIB","comparison_wrapper":"styles_comparison_wrapper__1ZCPi","sec_wrapper":"styles_sec_wrapper__5KYpQ","heading":"styles_heading__jkUu_"};